import React, {VoidFunctionComponent} from "react";

export const AutoPromoBanner: VoidFunctionComponent<{ relatedHtmlContent: string }> = ({relatedHtmlContent}) => (
    <div className='auto-promo-banner'>
        <div id='auto-promo-banner' className='auto-promo-banner-content'
             dangerouslySetInnerHTML={{__html: relatedHtmlContent}}>
        </div>
    </div>
)